import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const PERIODTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PeriodType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.PeriodType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const PERIODTYPE_CONFIG = {
  entityName: 'PeriodType',
  localizationKey: 'Controlling::Entity.PeriodType',
  fields: PERIODTYPE_FIELDS,
  permission: 'ControllingCalendar.PeriodTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
